import {AppContext} from './app-init';

//<div class="call-intent-button-container">
//	<div class="phone call-intent-content">
//		<img src="<%= assetPath('/phone.svg') %>" alt="phone">
//		<a class="GI-phone" href="tel:<%= phoneNumber %>"><%= phoneNumber %></a>
//	</div>
//	<div class="call-intent-trigger">
//		<span>Afficher le numéro</span>
//	</div>
//</div>

export class CallIntentButton {

	protected clickHandlers: ((e: MouseEvent) => void)[] = [];

	constructor(protected context: AppContext,
				protected containerSelector: string = '.call-intent-button-container',
				protected triggerSelector: string = '.call-intent-trigger',
				protected contentSelector: string = '.call-intent-content') {}

	public init(): this {
		this.getContainers().forEach((container: HTMLElement) => this.listenEvents(container));
		return this;
	}

	public onClick(fn: (e: MouseEvent) => void): this {
		this.clickHandlers.push(fn);
		return this;
	}

	protected listenEvents(container: HTMLElement) {
		container.querySelector(this.triggerSelector)
			?.addEventListener('click', (e: MouseEvent) => this.handleTriggerClick(e));
	}

	protected contentShown = false;

	protected handleTriggerClick(e: MouseEvent) {
		if(this.contentShown) return;
		this.showContent();
		this.triggerCallIntent();
		this.clickHandlers.forEach((handler) => handler(e));
	}

	protected triggerCallIntent() {
		if(!this.context?.CampaignId) return;
		const {
			NetworkSlug,
			OperationId,
			FranchiseSlug,
			CampaignId
		} = this.context;
		fetch(`/api/express/${NetworkSlug}/${OperationId}/${FranchiseSlug}/${CampaignId}/call-intent`, {method: 'POST'})
			.then(response => response.json())
			.then(data => console.log(data))
			.catch(err => console.log(err));
	}

	protected showContent() {
		this.contentShown = true;
		this.getContainers().forEach((container: HTMLElement) => container?.classList?.add('show-content'));
	}

	protected getContainers(): NodeListOf<HTMLElement> {
		return document.querySelectorAll(this.containerSelector);
	}
}
